import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

export const usePostSubscriber = () => {
  const { post } = useFetch<string>(getAbsoluteServerUrl('/subscriptors'), { responseType: 'json' })
  return (email: string) => {
    return post({ email })
  }
}
